import { render, staticRenderFns } from "./WidgetPanel.vue?vue&type=template&id=63662870&scoped=true&"
import script from "./WidgetPanel.vue?vue&type=script&lang=js&"
export * from "./WidgetPanel.vue?vue&type=script&lang=js&"
import style0 from "./WidgetPanel.vue?vue&type=style&index=0&id=63662870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63662870",
  null
  
)

export default component.exports